/**
 * management target pokemon's speed status & character for auto speed control
 */
const state={
    auto_level:50,//レベル(1<=x<=100)
    auto_s_ind:31,//S個体値(0<=x<=31)
    auto_s_eff:0,//S努力値(0<=x<=252)
    auto_up_character:"---",//性格上昇補正対象
    auto_down_character:"---",///性格下降補正対象
    auto_rank:0,//ランク補正(~6<=x<=6)
    auto_skill:1,//特性補正(0.5<=x<=2)
    auto_item:1,//道具補正(0.5<=x<=2)
    auto_paralysis:1,//麻痺の有無(0.5<=x<=1)
};

const getters={
    getAutoLevel(state){
        return state.auto_level;
    },
    getAutoSInd(state){
        return state.auto_s_ind;
    },
    getAutoSEff(state){
        return state.auto_s_eff;
    },
    getAutoUpCharacter(state){
        return state.auto_up_character;
    },
    getAutoDownCharacter(state){
        return state.auto_down_character;
    },
    getAutoRank(state){
        return state.auto_rank;
    },
    getAutoSkill(state){
        return state.auto_skill;
    },
    getAutoItem(state){
        return state.auto_item;
    },
    getAutoParalysis(state){
        return state.auto_paralysis;
    },
};

const mutations={
    /**
     * レベルの登録
     * @param {this} state 
     * @param {Number} auto_level 
     */
    saveAutoLevel(state,auto_level){
        state.auto_level=auto_level;
    },
    /**
     * S個体値の登録
     * @param {this} state 
     * @param {Number} auto_s_ind 
     */
    saveAutoSInd(state,auto_s_ind){
        state.auto_s_ind=auto_s_ind;
    },
    /**
     * S努力値の登録
     * @param {this} state 
     * @param {Number} auto_s_eff 
     */
    saveAutoSEff(state,auto_s_eff){
        state.auto_s_eff=auto_s_eff;
    },
    /**
     * 性格上昇補正をかける能力名の登録
     * @param {this} state 
     * @param {String} auto_up_character 
     */
    saveAutoUpCharacter(state,auto_up_character){
        state.auto_up_character=auto_up_character;
    },
    /**
     * 性格下降補正をかける能力名の登録
     * @param {this} state 
     * @param {String} auto_down_character 
     */
    saveAutoDownCharacter(state,auto_down_character){
        state.auto_down_character=auto_down_character;
    },
    /**
     * ランク補正の登録
     * @param {this} state 
     * @param {Number} auto_rank 
     */
    saveAutoRank(state,auto_rank){
        state.auto_rank=auto_rank;
    },
    /**
     * スキル補正の登録
     * @param {this} state 
     * @param {Number} auto_skill 
     */
    saveAutoSkill(state,auto_skill){
        state.auto_skill=auto_skill;
    },
    /**
     * 道具による補正の登録
     * @param {this} state 
     * @param {Number} auto_item 
     */
    saveAutoItem(state,auto_item){
        state.auto_item=auto_item;
    },
    /**
     * 麻痺による補正の登録
     * @param {this} state 
     * @param {Number} auto_paralysis 
     */
    saveAutoParalysis(state,auto_paralysis){
        state.auto_paralysis=auto_paralysis;
    },
};

const actions={
    saveAutoLevel({commit},auto_level){
        commit("saveAutoLevel",auto_level);
    },
    saveAutoSInd({commit},auto_s_ind){
        commit("saveAutoSInd",auto_s_ind);
    },
    saveAutoSEff({commit},auto_s_eff){
        commit("saveAutoSEff",auto_s_eff);
    },
    saveAutoUpCharacter({commit},auto_up_character){
        commit("saveAutoUpCharacter",auto_up_character);
    },
    saveAutoDownCharacter({commit},auto_down_character){
        commit("saveAutoDownCharacter",auto_down_character);
    },
    saveAutoRank({commit},auto_rank){
        commit("saveAutoRank",auto_rank);
    },
    saveAutoSkill({commit},auto_skill){
        commit("saveAutoSkill",auto_skill);
    },
    saveAutoItem({commit},auto_item){
        commit("saveAutoItem",auto_item);
    },
    saveAutoParalysis({commit},auto_paralysis){
        commit("saveAutoParalysis",auto_paralysis);
    },
};

const autoSpeed={
    namespaced:true,//important
    state,
    getters,
    actions,
    mutations
};

export default autoSpeed;